import { makeStyles } from '@mui/styles';
import Checkbox from 'apollo-react/components/Checkbox';
import Typography from 'apollo-react/components/Typography';
import React from 'react';
import { useDispatch } from 'react-redux';

import { useSavedSearchSelector } from '../../custom-hooks';
import { useTranslation } from '../../custom-hooks/useTranslation';
import { editSavedSearch } from '../actions/editor.actions';
import { getSavedSearchProp } from '../selectors/editor.selectors';

const useStyles = makeStyles({
  checkboxWrapper: {
    height: 40,
    display: 'flex',
    alignItems: 'center',
  },
  rowLabel: {
    width: 200,
    paddingTop: 8,
    marginRight: 20,
    alignItems: 'center',
  },
});

const CheckboxControl = ({ label, prop, disabled, editAction = editSavedSearch }) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const translateString = useTranslation();

  const currentValue = useSavedSearchSelector(getSavedSearchProp, { prop });

  const handleChange = ({ target: { checked } }) => {
    const value = prop === 'showInDashboard' ? (checked ? 1 : 0) : checked;
    dispatch(editAction({ prop, value }));
  };

  return (
    <div className={classes.checkboxWrapper}>
      <div className={classes.rowLabel}>
        <Typography>{translateString(label)}</Typography>
      </div>
      <div className={classes.rowColumn}>
        <Checkbox
          checked={currentValue}
          disabled={disabled}
          onChange={handleChange}
          aria-label={translateString(label)}
        />
      </div>
    </div>
  );
};

export default CheckboxControl;
